import { c as _c } from "react/compiler-runtime";
import { Controller, UseFormReturn } from "react-hook-form";
import FormPartTitle from "@/components/form/form-part-title";
import { FormTextArea } from "@/components/global/form/inputs/form-textarea";
import { TestimonyRead } from "@/TS/Interfaces/global_interfaces";
import { SendTestimonyFormValues } from "../schemas/schema";
export const TestimonyText = t0 => {
  const $ = _c(8);
  const {
    methods,
    error
  } = t0;
  const {
    formState: t1
  } = methods;
  const {
    errors,
    isSubmitted
  } = t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <FormPartTitle className="mb-[1.25rem] mt-[1.25rem]" classNameTitle="!text-base tracking-[.8px]">CONTENU DU TÉMOIGNAGE</FormPartTitle>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== error || $[2] !== errors || $[3] !== isSubmitted) {
    t3 = t4 => {
      const {
        field
      } = t4;
      const characterCount = field.value?.length || 0;
      return <div className="mb-[1.25rem]"><FormTextArea {...field} name="description" label={"T\xE9moignage (limit\xE9 \xE0 550 caract\xE8res)"} required={true} error={error || errors.description?.message} isValid={isSubmitted && !errors.description} placeholder={"Saisissez le texte du t\xE9moignage"} /><p className="text-right text-sm text-gray-500 mt-1">{characterCount} / 550</p></div>;
    };
    $[1] = error;
    $[2] = errors;
    $[3] = isSubmitted;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== methods.control || $[6] !== t3) {
    t4 = <>{t2}<Controller control={methods.control} name="description" render={t3} /></>;
    $[5] = methods.control;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};